import(/* webpackMode: "eager" */ "/home/runner/work/MONADATY/MONADATY/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/home/runner/work/MONADATY/MONADATY/components/cart-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/runner/work/MONADATY/MONADATY/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalErrorHandler"] */ "/home/runner/work/MONADATY/MONADATY/components/GlobalErrorHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionConfigWrapper"] */ "/home/runner/work/MONADATY/MONADATY/components/MotionConfigWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/home/runner/work/MONADATY/MONADATY/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistration"] */ "/home/runner/work/MONADATY/MONADATY/components/ServiceWorkerRegistration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StorefrontRouteTransition"] */ "/home/runner/work/MONADATY/MONADATY/components/StorefrontRouteTransition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/home/runner/work/MONADATY/MONADATY/components/ToastProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationHydrator"] */ "/home/runner/work/MONADATY/MONADATY/components/TranslationHydrator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WishlistProvider"] */ "/home/runner/work/MONADATY/MONADATY/components/wishlist-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/runner/work/MONADATY/MONADATY/context/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/MONADATY/MONADATY/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"DM_Serif_Display\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"400\",\"variable\":\"--font-dm-serif\"}],\"variableName\":\"dmSerifDisplay\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/MONADATY/MONADATY/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-dm-sans\"}],\"variableName\":\"dmSans\"}");
